export default __webpack_public_path__ + "static/media/cohort-home.e19f7c53.svg";